import { issueList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function IssueList() {
  return (
    <section id="issues" className="w-full scroll-mt-20 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="失效排查"
          title="常见访问问题，一眼看懂该怎么解决"
          desc="把最常遇到的几种情况整理成对照表，遇到问题先看症状，再照着解决方法操作即可。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
          {issueList.map((issue) => (
            <article
              key={issue.symptom}
              className="rise flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${issue.icon} text-xl`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {issue.symptom}
                </h3>
                <dl className="mt-3 space-y-2 text-xs leading-relaxed">
                  <div className="flex gap-2">
                    <dt className="w-14 shrink-0 text-secondary-700">原因</dt>
                    <dd className="flex-1 text-foreground-600">{issue.cause}</dd>
                  </div>
                  <div className="flex gap-2">
                    <dt className="w-14 shrink-0 font-medium text-accent-700">解决</dt>
                    <dd className="flex-1 text-foreground-700">{issue.solution}</dd>
                  </div>
                </dl>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}